export function formatDate(date) {
  if (!date) return date;

  // 1️⃣ Se já estiver no formato DD/MM/YYYY → retorna igual
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(date)) {
    return date;
  }

  // 2️⃣ Formato AAAA-MM-DD → trata como string para evitar timezone
  if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  }

  // 3️⃣ Qualquer outro formato → tenta converter normalmente
  const dateObj = new Date(date);
  if (!isNaN(dateObj)) {
    const d = String(dateObj.getDate()).padStart(2, "0");
    const m = String(dateObj.getMonth() + 1).padStart(2, "0");
    const y = String(dateObj.getFullYear());
    return `${d}/${m}/${y}`;
  }

  // 4️⃣ Se nada funcionar → retorna o original
  return date;
}


export function removeCharacters(item) {
  if (item) {
    const typeOfItem = typeof item === "string";
    return typeOfItem ? item.replace(/[^a-zA-Z0-9]/g, "") : "";
  }
  return item;
}

export function convertInString(item) {
  if (item !== null && item !== undefined && item !== "") {
    return item.toString();
  }
  return item;
}
